export default class Nav {
  constructor() {
    const hamburgerMenu = document.querySelectorAll('.hamburger-menu'),
    searchMenu = document.querySelectorAll('.search-menu'),
    fixedTop = document.querySelector('.fixed-top'),
    menu = document.querySelector('.navbar-nav .menu a'),
    submenu = document.querySelector('.subheader-highlight'),
    dropdowns = document.querySelectorAll('.dropdown-toggle');
    
    if (fixedTop) {
      this.scrollNav();
    }
    if (hamburgerMenu.length) {
      this.hamburgerMenu = hamburgerMenu;
      this.initSideNavState();
    }
    if (searchMenu.length) {
      this.searchMenu = searchMenu;
      console.log(searchMenu);
      
      this.initSearchNavState();
    }
    if (dropdowns.length) {
      this.dropdowns = dropdowns;
      this.hideDropdownOnClick();
    }
    if (menu) {
      this.initNavActiveState();
    }
    if (submenu) {
      this.initSubheaderActiveState();
    }
  }
  
  // Function to initialize the active state of the navigation
  initNavActiveState() {
    if (location.pathname != '/') {
      $('.main-nav li a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('active');
    }
  }
  
  // Add active state of the inner hardcoded subheader navigation
  initSubheaderActiveState() {
    const current = location.pathname;
    
    document.querySelectorAll(".subheader-highlight li a").forEach(link => {
      const path = new URL(link.href, location.origin).pathname;
      if (path === current) {
        link.parentElement.classList.add("Highlight");
      }
    });
  }
  
  // Function to add the class is-scrolling to the fixed-top element
  scrollNav() {
    const fixedTop = document.querySelector('.fixed-top'),
    hNavbar = document.querySelector('.h-navbar'),
    navBarNav = document.querySelector('.blur-container');
    
    let previousScroll = 0;
    let desktopScrollHandler = null;
    let mobileScrollHandler = null;
    
    // Function to set up desktop scroll behavior
    const setupDesktopScroll = () => {
      if (desktopScrollHandler) {
        window.removeEventListener('scroll', desktopScrollHandler);
      }
      
      desktopScrollHandler = function () {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        if (currentScroll < 100) {
          // At the top of the page
          fixedTop.classList.remove('is-scrolling');
        } else {
          fixedTop.classList.add('is-scrolling');
        }
        
        previousScroll = currentScroll;
      };
      
      window.addEventListener('scroll', desktopScrollHandler);
    };
    
    // Function to set up mobile scroll behavior
    const setupMobileScroll = () => {
      if (mobileScrollHandler) {
        window.removeEventListener('scroll', mobileScrollHandler);
      }
      
      mobileScrollHandler = function () {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        if (currentScroll < 100) {
          // At the top of the page - always show
          hNavbar.classList.remove('is-scrolling');
          hNavbar.classList.remove('navbar-hidden');
          // fixedTop.classList.remove('is-hidden');
          
          if (navBarNav) navBarNav.classList.remove('is-scrolling', 'navbar-hidden');
          
        } else if (currentScroll < previousScroll) {
          // Scrolling up - show navbar
          hNavbar.classList.add('is-scrolling');
          hNavbar.classList.remove('navbar-hidden');
          // fixedTop.classList.remove('is-hidden');
          
          if (navBarNav) {
            navBarNav.classList.add('is-scrolling');
            navBarNav.classList.remove('navbar-hidden');
          }
          
        } else if (currentScroll > previousScroll) {
          // Scrolling down - hide navbar
          hNavbar.classList.add('is-scrolling');
          hNavbar.classList.add('navbar-hidden');
          // fixedTop.classList.add('is-hidden');
          
          if (navBarNav) {
            navBarNav.classList.add('is-scrolling');
            navBarNav.classList.add('navbar-hidden');
          }
          
        }
        
        document.querySelector('.copyright')?.classList.toggle(
          'reset-bottom-space',
          navBarNav && navBarNav.classList.contains('navbar-hidden')
        );
        
        previousScroll = currentScroll;
      };
      
      window.addEventListener('scroll', mobileScrollHandler);
    };
    
    // Function to clean up all scroll listeners
    const cleanupScrollListeners = () => {
      if (desktopScrollHandler) {
        window.removeEventListener('scroll', desktopScrollHandler);
        desktopScrollHandler = null;
      }
      if (mobileScrollHandler) {
        window.removeEventListener('scroll', mobileScrollHandler);
        mobileScrollHandler = null;
      }
    };
    
    // Function to reset navbar classes
    const resetNavbarClasses = () => {
      if (hNavbar) {
        hNavbar.classList.remove('is-scrolling', 'navbar-hidden');
      }
      // if (fixedTop) {
      //   fixedTop.classList.remove('is-scrolling', 'is-hidden');
      // }
      if (navBarNav) {
        navBarNav.classList.remove('is-scrolling', 'navbar-hidden');
      }
      
    };
    
    // Function to initialize scroll behavior based on screen size
    const initScrollBehavior = () => {
      cleanupScrollListeners();
      resetNavbarClasses();
      
      if (fixedTop && window.innerWidth >= 992) {
        setupDesktopScroll();
      } else if (hNavbar && window.innerWidth <= 991) {
        setupMobileScroll();
      }
    };
    
    // Initialize on load
    // initScrollBehavior();
    
    // Add resize listener
    window.addEventListener('resize', function() {
      // Debounce resize events
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        // initScrollBehavior();
      }, 250);
    });
  }
  
  // Function to initialize the mobile navigation state
  initSideNavState() {
    const mobileOverlay = document.querySelector('.mobile-overlay'),
    body = document.querySelector('body'),
    mobileNav = document.querySelector('.mobile-nav'),
    mobileCloseNav = document.querySelector('.close-mobile-nav');
    
    if (this.hamburgerMenu) {
      this.hamburgerMenu.forEach (burger => {
        burger.addEventListener('click', function() {
          mobileNav.classList.add('active');
          mobileCloseNav.classList.add('open');
          mobileOverlay.classList.add('open');
          
          if (mobileOverlay.classList.contains('open')) {
            body.classList.add('overflow-hidden');
          }
        });
      });
    }
    
    if (mobileCloseNav) {
      mobileCloseNav.addEventListener('click', function() {
        mobileNav.classList.remove('active');
        mobileCloseNav.classList.remove('open');
        mobileOverlay.classList.remove('open');
        body.classList.remove('overflow-hidden');
      });
    }
  }

  // Function to initialize the search navigation state
  initSearchNavState() {
    const searchOverlay = document.querySelector('.search-overlay'),
    body = document.querySelector('body'),
    searchNav = document.querySelector('.search-nav'),
    searchCloseNav = document.querySelector('.close-search-nav');
    
    if (this.searchMenu) {
      this.searchMenu.forEach (menu => {
        menu.addEventListener('click', function() {
          searchNav.classList.add('active');
          searchCloseNav.classList.add('open');
          searchOverlay.classList.add('open');
          
          if (searchOverlay.classList.contains('open')) {
            body.classList.add('overflow-hidden');
          }
        });
      });
    }
    
    if (searchCloseNav) {
      searchCloseNav.addEventListener('click', function() {
        searchNav.classList.remove('active');
        searchCloseNav.classList.remove('open');
        searchOverlay.classList.remove('open');
        body.classList.remove('overflow-hidden');
      });
    }
  }
  
  // Function to hide main menu dropdown when clicking them
  // and to redirect to the href of the platform dropdown
  hideDropdownOnClick() {
    this.dropdowns.forEach(dropdown => {
      dropdown.addEventListener('click', function () {
        const dropdownMenu = dropdown.nextElementSibling;
        if (dropdownMenu && window.innerWidth >= '768') {
          dropdownMenu.classList.add('d-none');
        }
      });
    });
    
    const platform = document.getElementById('platform-dropdown');
    if (platform && window.innerWidth >= '768') {
      platform.addEventListener('click', function (e) {
        e.preventDefault();
        
        const url = platform.getAttribute('href');
        if (url) {
          window.location = url;
        }
      });
    }
    if (platform && window.innerWidth < '767') {
      platform.removeAttribute('href');
      platform.removeAttribute('data-url');
    }
  }
}